














import {Vue, Prop, Component } from 'vue-property-decorator';
import Passenger from '@/components/Passenger/models/Passenger';

@Component({
    components: {
    },
})
export default class PassengerInformationCard extends Vue {
  
  @Prop({ required: true }) private passenger!: Passenger;

  get phoneNumbers() {
    return this.passenger.phoneNumbers.map(p => p.number).join(', ');
  }

}
